module.exports = __webpack_public_path__ + "img/睦邻分中心3.3a868f18.jpg";